export const OptionIcon = () => {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8 1.54651C4.43584 1.54651 1.54651 4.43584 1.54651 8C1.54651 11.5642 4.43584 14.4535 8 14.4535C11.5642 14.4535 14.4535 11.5642 14.4535 8C14.4535 4.43584 11.5642 1.54651 8 1.54651ZM0.5 8C0.5 3.85786 3.85786 0.5 8 0.5C12.1421 0.5 15.5 3.85786 15.5 8C15.5 12.1421 12.1421 15.5 8 15.5C3.85786 15.5 0.5 12.1421 0.5 8ZM8 3.98837C8.28899 3.98837 8.52326 4.22264 8.52326 4.51163V7.47674H11.4885C11.7775 7.47674 12.0118 7.71101 12.0118 8C12.0118 8.28899 11.7775 8.52326 11.4885 8.52326H8.52326V11.4884C8.52326 11.7774 8.28899 12.0116 8 12.0116C7.71101 12.0116 7.47674 11.7774 7.47674 11.4884V8.52326H4.5118C4.22281 8.52326 3.98854 8.28899 3.98854 8C3.98854 7.71101 4.22281 7.47674 4.5118 7.47674H7.47674V4.51163C7.47674 4.22264 7.71101 3.98837 8 3.98837Z"
                fill="#0DD1C5"
            />
        </svg>
    );
};
